module.exports = __webpack_public_path__ + "static/media/APP01@s.c44d48b6.jpg";